import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthProfileService } from '@core/authentication/auth-profile.service';
import { IAuthProfile } from '@core/authentication/shared/auth-profile.model';

@Component({
    selector: 'ndd-user-menu-view-enterprise',
    template: require('./user-menu-view-enterprise.component.html'),
})
export class UserConfigViewEnterpriseComponent implements OnInit, OnDestroy {
    public enterprise: string;
    public domain: string;
    public logon: string;
    public email: string;
    public fullName: string;

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(private authProfileService: AuthProfileService) { }

    public ngOnInit(): void {
        this.authProfileService.onRefreshAuthProfileData$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: IAuthProfile) => {
                this.enterprise = response.enterpriseName;
                this.domain = response.domainName;
                this.logon = response.logonName;
                this.email = response.email;
                this.fullName = response.fullName;
            });
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
